export default "__VITE_ASSET__Y4EEL$oI__"